import React from 'react';
// import PropTypes from 'prop-types';
import InputStyles from '../InputStyles';

const ZipCodeInput = ({
    register,
    fieldName,
    label,
    formState: {errors = {}} = {},
    required,
    placeholder,
    errorMessage,
    helperText,
}) => {
    return (
        <InputStyles>
            <div className="label-container">
                <div>
                    <label
                        htmlFor={fieldName}
                        dangerouslySetInnerHTML={{__html: label}}
                    />
                    {required && <span className="required-asterisk">*</span>}
                </div>
                {helperText && <span className="helper-text">{helperText}</span>}
            </div>
            <input
                id={fieldName}
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                onInput={(e) => (e.target.value = e.target.value.slice(0, 5))} // limit char length to 5
                className={`${errors[fieldName] ? 'error' : ''}`}
                {...register(fieldName, {
                    required,
                    pattern: {
                        value: /^\d{5}$/i,
                        message: 'Invalid zip code.',
                    },
                })}
                placeholder={placeholder}
            />
            {errors[fieldName] && (
                <span className="input-error">
                    {errors[fieldName].message || errorMessage}
                </span>
            )}
        </InputStyles>
    );
};
export default ZipCodeInput;

// ZipCodeInput.propTypes = {
//     register: PropTypes.func.isRequired,
//     fieldName: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//     required: PropTypes.bool,
//     formState: PropTypes.object,
//     placeholder: PropTypes.string,
//     errorMessage: PropTypes.string,
//     helperText: PropTypes.string,
// };
